export enum BulkConfigurationType {
  MainDistribution = 1,
  Patrimony = 2,
  Frost = 3,
  SurveyStatus = 4,
  Quadrant = 5,
  XQuadrant = 6,
  SNS = 7,
  Prefill = 8,
  DeleteBuilding = 9,
  InsideSurveyValidation = 10,
  OutsideSurveyValidation = 11,
  BuildingGroupKey = 12,
  HandOver = 13,
  DeleteAddress = 14,
}
